module.exports = __webpack_public_path__ + "static/media/homePlate2Icon3.b064f71a.png";